import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1bba3df2&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bba3df2"]])

export default __exports__